import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { useContextMenuStore, useDrawMapStore, useDriveTimeStore, useStreetViewStore } from "../";
import { useConditionallyClosable } from "../hooks/useClosable";
import useNavigateToProperty from "../hooks/useNavigateToProperty";
import { GeoCoordinate } from "../interfaces/GeoCoordinate";
import { ClosableOrder } from "../store/ClosableStore";
import styles from './ContextMenu.module.css';

function ContextMenu() {
    const navigate = useNavigate();
    const navigateToProperty = useNavigateToProperty();
    const contextMenuStore = useContextMenuStore();
    const drawMapStore = useDrawMapStore();
    const driveTimeStore = useDriveTimeStore();
    const streetViewStore = useStreetViewStore();
    const coordinates = contextMenuStore.coordinates;
    const pageCoordinates = contextMenuStore.pageCoordinates;
    const parcelAtCoordinates = useMemo(() => coordinates && contextMenuStore.findParcelAtCoordinate?.(coordinates), [coordinates, contextMenuStore.findParcelAtCoordinate]);
    const shouldShowAddParcel = useMemo(() => !!contextMenuStore.onAddParcel && !parcelAtCoordinates, [contextMenuStore.onAddParcel, parcelAtCoordinates]);
    const shouldShowRemoveParcel = useMemo(() => !!contextMenuStore.onRemoveParcel && !!parcelAtCoordinates, [contextMenuStore.onRemoveParcel, parcelAtCoordinates]);
    const shouldHideDefaultOptions = useMemo(() => !!contextMenuStore.onAddParcel && !contextMenuStore.showDefaultOptions, [contextMenuStore.onAddParcel, contextMenuStore.showDefaultOptions]);
    useConditionallyClosable(ClosableOrder.Click, () => contextMenuStore.close(), !!coordinates);

    if (!coordinates || !pageCoordinates)
        return null;

    return (
        <div className={styles.container} style={{ top: pageCoordinates.y, left: pageCoordinates.x }}>
            <ul>
                {shouldShowAddParcel && (
                    <li onMouseDown={() => contextMenuStore.addParcel(coordinates)}>Add Parcel</li>
                )}
                {shouldShowRemoveParcel && (
                    <li onMouseDown={() => { contextMenuStore.removeParcel!(parcelAtCoordinates!.id); }}>Remove Parcel</li>
                )}
                {!shouldHideDefaultOptions && (<>
                    <li onMouseDown={() => navigateToProperty(coordinates.lng, coordinates.lat)}>View Property Info</li>
                    <li onMouseDown={() => window.open(`https://www.google.com/maps/place/${coordinates.lat},${coordinates.lng}`)}>View in Google Maps</li>
                    <li onMouseDown={() => navigate(`/locations/create/${coordinates.lng}/${coordinates.lat}`)}>Add Location</li>
                    <li onMouseDown={() => navigate(`/deals/createFromProperty/${coordinates.lng}/${coordinates.lat}`)}>Add Deal</li>
                    <li onMouseDown={() => navigate(`/leads/create/${coordinates.lng}/${coordinates.lat}`)}>Add Lead</li>
                    <li onMouseDown={() => navigate(`/leaseComps/create/${coordinates.lng}/${coordinates.lat}`)}>Add Lease Comp</li>
                    <li onMouseDown={() => navigate(`/saleComps/create/${coordinates.lng}/${coordinates.lat}`)}>Add Sale Comp</li>
                    <li onMouseDown={() => drawMapStore.drawMeasureArea()}>Measure Area</li>
                    <li onMouseDown={() => drawMapStore.drawMeasureDistance()}>Measure Distance</li>
                    <li onMouseDown={() => driveTimeStore.setCoordinates(new GeoCoordinate(coordinates.lat, coordinates.lng))}>View Drive Time</li>
                    <li onMouseDown={() => streetViewStore.setCoordinates(new GeoCoordinate(coordinates.lat, coordinates.lng))}>Street View</li>
                </>)}
            </ul>
        </div>
    );
}

export default observer(ContextMenu);
